import { mixins, styled, theme } from 'ui/theme';
import { ButtonIcon } from 'ui/components/primitives';

export const Breadcrumbs = {
  ButtonMore: styled(ButtonIcon)`
    color: ${theme.colors.action.navigation.standard.static};
  `,

  Component: styled.nav``,

  LastItemContent: styled.span`
    ${mixins.baseFont};
    color: ${theme.colors.build.mediumLight1};
    position: relative;
  `,

  List: styled.ol`
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
  `,

  MobileList: styled.ol`
    left: 50%;
    position: absolute;
    top: 100%;
    transform: translateX(-50%);

    li {
      display: flex;
      padding: ${theme.space[2]};
      white-space: nowrap;
    }
  `,
};
